import { Modal, ModalWindow } from '../../../components/Modal';
import { TextInputRaw } from '../../../components/Input/TextInputRaw';
import { Button } from '../../../components/common/Button';
import React, { useState } from 'react';
import { useAgencyDetails } from '../../../hooks/useAgencyDetails';
import { notifyUser } from '../../../components/authoring/hooks';
import { Link } from 'react-router-dom';
import { zyncRegistrationSources } from 'zync-common/hubspot';
import mixpanel from 'mixpanel-browser';
import { register } from '../../../auth';

export const RegisterModal = ({ setIsOpen, meetingSeriesId }) => {
  const { organizationName, orgLogoUrl } = useAgencyDetails();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setIsEmailValid(true);
      setIsSubmitting(true);
      setError('');
      try {
        const { error, status } = await register({
          emailAddress: email,
          registrationSourceId: zyncRegistrationSources.STANDARD_SIGN_UP,
          userMeetingSeriesId: meetingSeriesId,
        });

        setEmail('');

        if (status === 200) {
          setIsSubmitting(false);
          mixpanel.track('Registration Email Sent', {
            distinct_id: email,
          });
          notifyUser(`Registration email sent to ${email}`);
          setIsOpen(false);
        } else {
          notifyUser(error);
          setError(error);
          setIsSubmitting(false);
        }
      } catch (error) {
        setError(error?.message);
        setIsSubmitting(false);
      }
    } else {
      setError(error);
      setIsEmailValid(false);
    }
  };

  return (
    <ModalWindow
      showCancel
      bg="#fff"
      boxShadow="3xl"
      onCancel={() => setIsOpen(false)}
      size={Modal.size.md}
    >
      <img
        alt={`${organizationName} logo`}
        className="w-[142px] absolute -top-[120px] left-1/2 -translate-x-1/2"
        src={orgLogoUrl}
      />
      <div className="p-12">
        <h1 className="text-[24px] mb-6 text-blue-dark font-bold text-center">
          Unlock with a Free Account
        </h1>

        <p className="text-lg text-center mb-6">
          Create your <strong>free account</strong> to access the full content
          kit and save your work.
        </p>

        <form
          className="flex flex-col justify-center items-center"
          onSubmit={handleSubmit}
        >
          <div className="w-full">
            <TextInputRaw
              className="w-full !p-2"
              placeholder="name@domain.com"
              value={email}
              size="!p-2 !pl-3 !text-lg text-center"
              onChange={handleEmailChange}
            />
            {!isEmailValid && email !== '' && (
              <p className="text-red text-xs mt-1">Invalid email address</p>
            )}
          </div>
          <Button
            color={Button.colors.PURPLE}
            padding={Button.padding.MEDIUM}
            state={
              isSubmitting
                ? Button.states.LOADING
                : validateEmail(email)
                ? Button.states.DEFAULT
                : Button.states.DISABLED
            }
            type="submit"
          >
            <span className="text-base font-bold px-10 py-1">
              Access Full Content Kit
            </span>
          </Button>
          <span className="text-xxs mt-8">
            By registering, you agree to our{' '}
            <Link className="underline" to="/tos">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link className="underline" to="/privacy">
              Privacy Policy
            </Link>
          </span>
        </form>
      </div>
    </ModalWindow>
  );
};
